import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { homeFor } from '../components/Navigation';
import RsrLogo from '../components/RsrLogo';
import { C, FONT } from '../theme';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const u = await login(email, password);
      navigate(homeFor(u?.role));
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: '100%', padding: '11px 13px', border: `1px solid ${C.border}`,
    borderRadius: 8, fontSize: 14, outline: 'none', boxSizing: 'border-box', background: '#fff',
  };
  const labelStyle = { display: 'block', fontSize: 12, fontWeight: 600, marginBottom: 6, color: C.textMuted, textTransform: 'uppercase', letterSpacing: 0.4 };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', fontFamily: FONT, background: '#fff' }}>
      {/* Left brand panel */}
      <div style={{ flex: '0 0 42%', maxWidth: 560, background: C.sidebar, color: '#fff', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: 48, position: 'relative', overflow: 'visible' }}>
        <div style={{ position: 'absolute', top: -80, right: -80, width: 280, height: 280, borderRadius: '50%', background: 'rgba(255,255,255,0.04)' }} />
        <div style={{ position: 'absolute', bottom: -60, left: -60, width: 220, height: 220, borderRadius: '50%', background: 'rgba(226,45,45,0.10)' }} />
        <div style={{ position: 'relative', textAlign: 'center', overflow: 'visible' }}>
          <div style={{ background: '#fff', borderRadius: 16, padding: '16px 20px 20px 20px', display: 'inline-block', minWidth: 260, marginBottom: 10, overflow: 'visible', lineHeight: 0 }}>
            <RsrLogo width={220} showText={false} />
          </div>
          <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.55)', letterSpacing: 2, marginBottom: 30 }}>Khyati Portal · ERP</div>
          <h1 style={{ fontSize: 32, fontWeight: 800, margin: '0 0 8px', letterSpacing: -0.5 }}>Khyati Portal</h1>
          <p style={{ fontSize: 15, color: 'rgba(255,255,255,0.7)', margin: 0, maxWidth: 320, lineHeight: 1.5 }}>
            Enterprise ERP for RSR International — merchandising to dispatch, in one place.
          </p>
        </div>
        <div style={{ position: 'absolute', bottom: 28, fontSize: 11, color: 'rgba(255,255,255,0.4)', letterSpacing: 1 }}>RSR INTERNATIONAL · LUDHIANA</div>
      </div>

      {/* Right login form */}
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 32, background: '#fff' }}>
        <div style={{ width: '100%', maxWidth: 380 }}>
          <h2 style={{ fontSize: 24, fontWeight: 800, color: C.text, margin: '0 0 6px' }}>Sign in</h2>
          <p style={{ fontSize: 14, color: C.textMuted, margin: '0 0 28px' }}>Welcome back. Please enter your credentials.</p>

          {error && (
            <div style={{ background: '#FCEBEB', color: '#A32D2D', padding: '10px 14px', borderRadius: 8, marginBottom: 18, fontSize: 14 }}>{error}</div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 16 }}>
              <label style={labelStyle}>Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" required style={inputStyle} />
            </div>
            <div style={{ marginBottom: 24 }}>
              <label style={labelStyle}>Password</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Enter password" required style={inputStyle} />
            </div>
            <button type="submit" disabled={loading}
              style={{ width: '100%', padding: 12, background: loading ? '#8a89c4' : C.navy, color: 'white', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer' }}>
              {loading ? 'Signing in…' : 'Sign in'}
            </button>
          </form>

          <p style={{ fontSize: 12, color: '#aaa', marginTop: 28, textAlign: 'center' }}>© RSR International · Khyati Portal</p>
        </div>
      </div>
    </div>
  );
}
